import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { useFormikContext } from "formik";
import Errors from "components/rules/rule-builder/Errors";
import { ConfirmDialog, Radio } from "components/common";
import RuleBuilderBlock from "components/rules/rule-builder/RuleBuilderBlock";
import { Panel } from "components/bootstrap";
import useStreamOutputRuleBuilder, { fetchValidateRule } from "components/streams/hooks/useStreamOutputRuleBuilder";
import generateObjectId from "logic/generateObjectId";
const StyledPanel = styled(Panel)(
  ({ theme }) => css`
    background-color: ${theme.colors.global.contentBackground};
    border: 0;
    box-shadow: none;
    margin-bottom: 0;
  `
);
const StyledPanelHeading = styled(Panel.Heading)(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    background-color: ${theme.colors.table.row.backgroundStriped} !important;
    border: 0;
  `
);
const WhenOperator = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    align-items: center;
  `
);
const StyledPanelBody = styled(Panel.Body)`
  border: 0;
  padding: 0;
`;
const FilterRulesFields = ({ type }) => {
  var _a, _b, _c, _d, _e, _f;
  const { values, setFieldValue, setValues } = useFormikContext();
  const [blockToDelete, setBlockToDelete] = useState(null);
  const newConditionBlockIndex = (_b = (_a = values.rule) == null ? void 0 : _a.conditions) == null ? void 0 : _b.length;
  const { conditions } = useStreamOutputRuleBuilder();
  const validateAndUpdateFormValues = (ruleToValidate) => fetchValidateRule(ruleToValidate).then((ruleValidated) => {
    setValues({ ...values, rule: ruleValidated.rule });
  }).catch(() => setValues(ruleToValidate));
  const addBlock = async (blockType, block) => {
    var _a2;
    if (blockType === "condition") {
      const ruleToValidate = {
        ...values,
        rule: {
          ...values.rule,
          conditions: [...((_a2 = values.rule) == null ? void 0 : _a2.conditions) || [], { ...block, id: generateObjectId() }]
        }
      };
      validateAndUpdateFormValues(ruleToValidate);
    }
  };
  const updateBlock = async (orderIndex, blockType, block) => {
    if (blockType === "condition") {
      const currentConditions = [...values.rule.conditions];
      currentConditions[orderIndex] = block;
      const ruleToValidate = { ...values, rule: { ...values.rule, conditions: currentConditions } };
      validateAndUpdateFormValues(ruleToValidate);
    }
  };
  const deleteBlock = (orderIndex, blockType) => {
    if (blockType === "condition") {
      const currentConditions = [...values.rule.conditions];
      currentConditions.splice(orderIndex, 1);
      const ruleToValidate = { ...values, rule: { ...values.rule, conditions: currentConditions } };
      validateAndUpdateFormValues(ruleToValidate);
    }
  };
  return /* @__PURE__ */ React.createElement(StyledPanel, { expanded: true }, /* @__PURE__ */ React.createElement(StyledPanelHeading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, type === "condition" ? "When" : "Then"), type === "condition" && /* @__PURE__ */ React.createElement(WhenOperator, null, /* @__PURE__ */ React.createElement(
    Radio,
    {
      name: "operator",
      checked: ((_c = values.rule) == null ? void 0 : _c.operator) === "AND",
      onChange: () => setFieldValue("rule.operator", "AND")
    },
    "and"
  ), /* @__PURE__ */ React.createElement(
    Radio,
    {
      name: "operator",
      checked: ((_d = values.rule) == null ? void 0 : _d.operator) === "OR",
      onChange: () => setFieldValue("rule.operator", "OR")
    },
    "or"
  ))), /* @__PURE__ */ React.createElement(Panel.Collapse, null, /* @__PURE__ */ React.createElement(StyledPanelBody, null, (_f = (_e = values.rule) == null ? void 0 : _e[`${type}s`]) == null ? void 0 : _f.map((item, index) => /* @__PURE__ */ React.createElement(
    RuleBuilderBlock,
    {
      key: item.id,
      blockDict: conditions || [],
      block: item,
      order: index,
      type,
      addBlock,
      updateBlock,
      deleteBlock: () => setBlockToDelete({ orderIndex: index, type })
    }
  )), /* @__PURE__ */ React.createElement(
    RuleBuilderBlock,
    {
      blockDict: conditions || [],
      order: newConditionBlockIndex,
      type,
      addBlock,
      updateBlock,
      deleteBlock: () => setBlockToDelete({
        orderIndex: newConditionBlockIndex,
        type
      })
    }
  ))), blockToDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: `Delete ${blockToDelete.type}`,
      show: true,
      onConfirm: () => {
        deleteBlock(blockToDelete.orderIndex, blockToDelete.type);
        setBlockToDelete(null);
      },
      onCancel: () => setBlockToDelete(null)
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, "Are you sure you want to delete", " ", /* @__PURE__ */ React.createElement("strong", null, blockToDelete.type, " N\xB0 ", blockToDelete.orderIndex + 1), "?")
  ), /* @__PURE__ */ React.createElement(Errors, { objectWithErrors: values.rule }));
};
export default FilterRulesFields;
